// Add Selleasy Tracking
async function AddSelleasyTracking() {
  try {
    document.querySelectorAll("lb-product-card").forEach((element) => {
      try {
        const checkboxObj = element.querySelector(".lb-spc-details-checkbox");

        if (checkboxObj) {
          let addOnsDiscount = document.querySelector(
            ".lb-upsell-ppa-offer-desc"
          ).innerHTML;
          addOnsDiscount = addOnsDiscount.match(/\d+/);
          addOnsDiscount = addOnsDiscount ? parseInt(addOnsDiscount[0], 10) : null;

          const eventFields = {
            page: document.title,
            product: item.Name,
            currency: Shopify.currency.active,
            sale_price: item.Price.replace("$", ""),
            price: item.CompareAtPrice.replace("$", ""),
            add_ons: element.querySelector(".lb-spc-details-name").innerText,
            add_ons_sale_price: element
              .querySelector(".lb-spc-details-sale-price")
              .innerText.replace("$", ""),
            add_ons_discount: addOnsDiscount,
            add_ons_price: element
              .querySelector(".lb-spc-details-cmp-price")
              .innerText.replace("$", ""),
          };

          checkboxObj.addEventListener(
            "change",
            () => {
              try {
                if (checkboxObj.checked && hasGtag()) {
                  gtag("event", "Selleasy", eventFields);
                }
              } catch (eventError) {
                console.log("Error triggering custom event:", eventError);
              }
            },
            false
          );
        }
      } catch (elementError) {
        console.log("Error processing element:", elementError);
      }
    });
  } catch (error) {
    console.log("Error in AddSelleasyTracking function:", error);
  }
}

// Selleasy tracking disabled
// window.addEventListener("load", function () {
//   setTimeout(AddSelleasyTracking, 3000);
// });

// --> Cedar Planters Tracking
var scrollThresholds = [25, 50, 75, 90, 100];
var tracked = [];
var scrollTicking = false;

function hasGtag() {
  return typeof window.gtag === "function";
}

function hasFbq() {
  return typeof window.fbq === "function";
}

function sendScrollEvent(depth) {
  // Google Ads event
  if (hasGtag()) {
    gtag("event", "scroll_" + depth, {
      event_category: "Scroll",
      event_label: depth + "%",
      value: depth,
    });
  }

  // Meta Ads event
  if (hasFbq()) {
    fbq("trackCustom", "ScrollDepth" + depth, {
      depth: depth + "%",
    });
  }
}

function trackScroll() {
  scrollTicking = false;
  var scrollPosition = window.scrollY + window.innerHeight;
  var documentHeight = document.documentElement.scrollHeight;

  var scrollPercent = Math.round((scrollPosition / documentHeight) * 100);

  for (var i = 0; i < scrollThresholds.length; i++) {
    if (
      scrollPercent >= scrollThresholds[i] &&
      !tracked.includes(scrollThresholds[i])
    ) {
      sendScrollEvent(scrollThresholds[i]);
      tracked.push(scrollThresholds[i]);
    }
  }

  if (tracked.length === scrollThresholds.length) {
    window.removeEventListener("scroll", onScroll);
  }
}

function onScroll() {
  if (scrollTicking) return;
  scrollTicking = true;
  window.requestAnimationFrame(trackScroll);
}

function initScrollTracking(attempt) {
  attempt = attempt || 0;
  if (hasGtag() || hasFbq()) {
    window.addEventListener("scroll", onScroll, { passive: true });
  } else if (attempt < 20) {
    setTimeout(function () {
      initScrollTracking(attempt + 1);
    }, 500);
  }
}

if (document.readyState === "complete") {
  initScrollTracking();
} else {
  window.addEventListener("load", function () {
    initScrollTracking();
  });
}
// --> End Cedar Planters Tracking
